import * as React from 'react'
import {Theme, styled, useTheme} from '@mui/material/styles'
import OutlinedInput from '@mui/material/OutlinedInput'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select, {SelectChangeEvent} from '@mui/material/Select'

type Props = {
  dataSelect: any
  handleChangeRowPerPage: (row: number) => void
  defaultValue: number
}

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
}

const CustomInput = styled(OutlinedInput)(({theme}) => ({
  '& .MuiInputBase-input': {
    padding: '8.5px 10px',
  },
  '& .MuiInputLabel-root': {
    color: '#000',
    transform: 'translate(14px, -9px) scale(0.85)',
    backgroundColor: '#fff',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(0, 0, 0, 0.1)',
  },
  '& legend': {
    width: 'inherit',
  },
}))

const SelectWithoutLabel = ({dataSelect, handleChangeRowPerPage, defaultValue}: Props) => {
  const theme = useTheme()
  const [valueSelect, setValueSelect] = React.useState('20')

  const handleChange = (event: SelectChangeEvent) => {
    setValueSelect(event.target.value as string)
    handleChangeRowPerPage(parseInt(event.target.value as string))
  }

  React.useEffect(() => {
    if(defaultValue.toString() != valueSelect) {
      setValueSelect(defaultValue.toString())
    }
  },[defaultValue])

  return (
    <div>
      <FormControl sx={{m: 1, minWidth: 50}}>
        <Select
          value={valueSelect}
          onChange={handleChange}
          input={<CustomInput />}
          MenuProps={MenuProps}
          inputProps={{'aria-label': 'Without label'}}
        >
          {dataSelect.map((o: any) => (
            <MenuItem key={o} value={o} >
              {o}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export {SelectWithoutLabel}
